// extracted by mini-css-extract-plugin
export default {"pageTitle":"edit-ticket-page_pageTitle__PrPZL","cancelBtn":"edit-ticket-page_cancelBtn__NNOp+"};